import { jsx as C } from "react/jsx-runtime";
function e() {
  return /* @__PURE__ */ C("svg", { width: "18", height: "18", viewBox: "0 0 18 18", fill: "none", children: /* @__PURE__ */ C(
    "path",
    {
      d: "M16.5009 0H1.49915C1.10164 0.000270725 0.720478 0.158285 0.439392 0.439402C0.158306 0.720519 0.000270695 1.1018 0 1.49936V16.5006C0 16.8983 0.157947 17.2797 0.439092 17.5608C0.720237 17.842 1.10155 18 1.49915 18H9.75008V11.2545H7.50188V8.25382H9.75008V6.31206C9.70193 5.83691 9.75842 5.35701 9.91558 4.90603C10.0727 4.45504 10.3267 4.04391 10.6598 3.7016C10.9928 3.3593 11.3967 3.09407 11.8432 2.9246C12.2896 2.75513 12.7678 2.68563 13.244 2.72075C13.944 2.71668 14.6437 2.75064 15.34 2.8228V5.25211H13.9021C12.778 5.25211 12.5563 5.78872 12.5563 6.5808V8.25082H15.8867L15.1366 11.2505H12.5563V17.9958H16.5009C16.8985 17.9958 17.2798 17.8378 17.5609 17.5566C17.8421 17.2754 18 16.8943 18 16.4967V1.49511C17.9986 1.09826 17.8401 0.718139 17.5592 0.437905C17.2782 0.157671 16.8977 0.000268034 16.5009 0Z",
      fill: "#030303"
    }
  ) });
}
export {
  e as default
};
